<tam-dialog class="relationship-dialog" [opened]="opened" [dialogWidth]="dialogWidth" #dialogRef>
    <ng-template #title>
        <span class="dialog-title">Edit Relationship Type</span>
        <smart-icon class="dialog-close dark" name="close" (click)="clickClose('cancel', $event)">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="relationship-content">
            <div class="flex-box">
                <div class="relationshipType-name">
                    <span>Relationship Type Name </span>
                </div>
                <div class="tam-form-field" [ngClass]="{'has-error':nameDuplicated||name.invalid}">
                    <input class="tam-input tam-textbox" style="width: 100%;" [(ngModel)]="relationshipTypeName"
                        [formControl]="name" (ngModelChange)="onRelationshipTypeNameChange($event)" />
                    <div class="tam-form-help" *ngIf="name.invalid && name.errors['required']">
                        {{'general.required_error_message' | stringLiterals}}
                    </div>
                    <div class="tam-form-help" *ngIf="nameDuplicated">
                        {{'general.name_already_exist' | stringLiterals}}
                    </div>
                    <div class="tam-form-help" *ngIf="name.invalid && name.errors['maxlength']">
                        {{'general.name_exceed_maximum' | stringLiterals: '128'}}
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="footer-container">
            <div>
                <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button dialog-cancel"
                    (click)="onCancelBtnClick($event)" [disabled]="isAutoSaving&&!editingEntryId">{{'general.cancel' |
                    stringLiterals}}</button>
                <button tam-button tamType="primary" tamSize="normal" class="dialog-button dialog-publish"
                    (click)="editRelationship()">{{'general.submit' | stringLiterals}}</button>
            </div>
        </div>
    </ng-template>
</tam-dialog>